import { XCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { RejectionRecord } from '@/types/rejection';

/** Layout the banner is rendered in — each breakpoint of the week toolbar renders its own variant. */
export type StatusBannerVariant = 'desktop' | 'tablet' | 'mobile';

export interface RejectionBannerProps {
  variant: StatusBannerVariant;
  isRejected: boolean;
  pendingRejection: RejectionRecord | null;
}

/** Rejection alert shown while a timesheet is awaiting correction. */
export function RejectionBanner({ variant, isRejected, pendingRejection }: RejectionBannerProps) {
  if (!isRejected || !pendingRejection) return null;

  if (variant === 'desktop') {
    return (
      <div className="flex items-start gap-2 border border-red-400 bg-red-50 dark:bg-red-950/20 rounded px-2.5 py-1.5">
        <XCircle className="h-3 w-3 text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" />
        <div className="flex flex-col min-w-0">
          <span className="font-semibold text-red-900 dark:text-red-100 leading-tight" style={{ fontSize: '12px' }}>Timesheet Rejected – Action Required</span>
          <span className="text-red-800 dark:text-red-200 leading-tight" style={{ fontSize: '12px' }}>{pendingRejection.rejectionReason}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={cn(
      'flex items-center gap-1.5 border border-red-400 bg-red-50 dark:bg-red-950/20 rounded px-2 py-1',
      variant === 'tablet' && 'min-w-0'
    )}>
      <XCircle className="h-3 w-3 text-red-600 dark:text-red-400 flex-shrink-0" />
      <span className="font-semibold text-red-900 dark:text-red-100 flex-shrink-0" style={{ fontSize: '12px' }}>Timesheet Rejected</span>
      <span className="text-red-800 dark:text-red-200 truncate" style={{ fontSize: '12px' }}>· {pendingRejection.rejectionReason}</span>
    </div>
  );
}
